import template from './admin-hotel-search.html';
import './admin-hotel-search.scss';

AdminHotelSearch.DIRECTIVE_NAME = 'ktAdminHotelSearch';
export default function AdminHotelSearch() {
    return {
        restrict: 'A',
        controller: AdminHotelSearchController,
        controllerAs: 'adminHotelSearchCtrl',
        template,
        bindToController: true,
        link,
    };

    function link($scope, $elem, $attrs, adminHotelSearchCtrl) {
        adminHotelSearchCtrl.$onInit();
    }
}

export function AdminHotelSearchController($timeout,
                                           adminHotelSearchService) {
    'ngInject';
    const vm = this;
    const showAllOptionId = 'all';
    const showAllOption = {
        id: showAllOptionId,
        label: 'Show All',
        priority: -1,
    };
    const DEFAULT_RADIUS = 20;

    const defaultSearchParams = {
        name: '',
        suppliers: [],
        min: 0,
        max: 20,
        latitude: null,
        longitude: null,
    };

    Object.assign(vm, {
        $onInit,
        onLocationSelect,
        onLocationChange,
        searchHotels,
        onSupplierSelect,
        isRadiusSelectVisible,
        getLocations,
        location: '',
        suppliers: [],
    });

    function $onInit() {
        initDefaultParameters();
        initSlider();
        composeSuppliers();
    }

    function onLocationChange() {
        vm.search.latitude = null;
        vm.search.longitude = null;
        vm.search.searchRadius = null;
    }

    function initSlider() {
        vm.slider = {
            value: DEFAULT_RADIUS,
            options: {
                showSelectionBar: true,
                floor: 1,
                ceil: 30,
                step: 1,
                onEnd: () => {
                    vm.search.searchRadius = vm.slider.value;
                },
            },
        };
    }

    function initDefaultParameters() {
        vm.search = angular.copy(defaultSearchParams);
    }

    function isRadiusSelectVisible() {
        return !!(vm.search.latitude && vm.search.longitude);
    }

    function composeSuppliers() {
        const suppliers = adminHotelSearchService.getSuppliers();
        vm.suppliers = [showAllOption, ...suppliers];
    }

    function getLocations(query) {
        return adminHotelSearchService.getLocations(query);
    }

    function searchHotels() {
        adminHotelSearchService.navigateToResultPage(vm.search, vm.suppliers);
    }

    function onSupplierSelect(selectedId, isChecked) {
        $timeout(() => {
            if (areAllSuppliersSelected() || isJustShowAllSelected()) {
                selectShowAll();
            } else {
                deselectShowAll();
            }

            if (selectedId === showAllOptionId) {
                if (isChecked) {
                    selectShowAll();
                } else {
                    deselectAllOptions();
                }
            }
        });

        function isJustShowAllSelected() {
            return vm.search.suppliers.length === 1
                ? vm.search.suppliers[0] === showAllOptionId
                : false;
        }

        function areAllSuppliersSelected() {
            return adminHotelSearchService.getSuppliers().every(({id}) =>
                vm.search.suppliers.includes(id));
        }

        function deselectShowAll() {
            vm.search.suppliers = vm.search.suppliers.filter((supplier) =>
                !angular.equals(supplier, showAllOptionId));
        }

        function selectShowAll() {
            vm.search.suppliers = vm.suppliers.map(({id}) => id);
        }

        function deselectAllOptions() {
            vm.search.suppliers = [];
        }
    }

    function onLocationSelect(selection) {
        adminHotelSearchService.getPlaceDetails(selection.place_id)
            .then(extractLocationInfo);
    }

    function extractLocationInfo(resp) {
        const {location} = resp.geometry;
        Object.assign(vm.search, {
            latitude: location.lat(),
            longitude: location.lng(),
        });
        vm.search.searchRadius = vm.slider.value;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-list/admin-hotel-search/admin-hotel-search-component.js